//导入request.js
import http from "@/utils/index";//@==>src
// 获取公告
export function getgonggao(params) {
    return http({
        url:"/teaching/commonality/queryList",
        method: "get",
        params
    })
}
// 获取新闻
export function getnews(params) {
    return http({
        url:"/teaching/news/list",
        method: "get",
        params
    })
}
// 获取精选实验
export function getgoodExp(params) {
    return http({
        url:"/teaching/SelectiveExperiment/list",
        method: "get",
        params
    })
}
// 获取banner
export function getbanner(params) {
    return http({
        url:"/teaching/banner/list",
        method: "get",
        params
    })
}
// 获取精选课程
export function getjxcourse(params) {
    return http({
        url:"/teaching/selectiveCourse/list",
        method: "get",
        params
    })
}